'use client';

/** Pending surface — honest under-construction state (coverage ledger tracks
 *  which phase delivers it; classic UI remains available for these). */
import { mono } from '@/future/primitives';

const PHASE: Record<string, string> = {
  'video-lab': 'P4', 'ab-tests': 'P4', ads: 'P4', factory: 'P4', websites: 'P4',
  compose: 'P4', contacts: 'P4', senders: 'P4',
  brain: 'P5', network: 'P5', chat: 'P5', settings: 'P5', content: 'P6',
};

export function PendingSurface({ tool }: { tool: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-24 gap-4">
      <div className="w-20 h-20 rounded-full border border-dashed flex items-center justify-center"
        style={{ borderColor: 'rgba(255,195,107,.4)', animation: 'uifRingA 12s linear infinite' }}>
        <div className="w-2.5 h-2.5 rounded-full" style={{ background: 'var(--uif-warn)', boxShadow: '0 0 10px rgba(255,195,107,.7)' }} />
      </div>
      <div style={{ ...mono(19, '.34em'), color: 'var(--uif-t3)' }}>{tool.replace('-', ' ').toUpperCase()} · UNDER CONSTRUCTION</div>
      <div style={{ ...mono(16, '.18em'), color: 'var(--uif-t5)' }}>
        ARRIVES IN {PHASE[tool] || 'A LATER PHASE'} · FULLY OPERATIONAL IN CLASSIC UI
      </div>
      <a href={tool === 'content' ? '/content' : `/${tool}`} target="_blank" rel="noopener noreferrer"
        className="mt-2 px-4 py-1.5 rounded-full transition-colors hover:bg-white/5"
        style={{ ...mono(16, '.2em'), color: 'var(--uif-cy-interactive)', border: '1px solid rgba(125,232,255,.3)' }}>
        OPEN CLASSIC SURFACE ↗
      </a>
    </div>
  );
}
